















































































































































import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

import APIService from '@/api';
import CampaignService from '@/api/CampaignService';
import AdminService from '@/api/AdminService';
import BusinessService from '@/api/BusinessService';

import eventBus from '@/utils/eventBus';
import mobileCheck from '@/utils/mobile-check';
import { closeIframeAfterSigninConnect } from '@/utils/providerIframe';
import {
  addHotjarScript,
  sendEventHotjarByTypeAndDescription
} from '@/utils/hotjar';
import { setCSSVariables } from '@/utils/theme';
import { cdnBaseURL } from '@/utils/cdn';

import { ConfirmDialogCallbacks } from '@/models/confirm-dialog';
import { AnalyticsOptions, AnalyticsSendTo } from '@/models/analytics-options';
import {
  IHotjarEventDescritpion,
  IHotjarEventType
} from '@/models/hotjar-options';
import { INotificationData } from '@/models/notification';

import flagKeys from '@/constants/flagKeys';

import ModalOptions from '@/components/Modal/ModalOptions';
import ScreenLocker from '@/components/ScreenLocker.vue';
import SideModal from '@/components/SideModal/SideModal.vue';
import ConfirmDialog from '@/components/organisms/ConfirmDialog/ConfirmDialog.vue';
import ForgotPassword from '@/views/Forgot/ForgotPasswordModal.vue';
import CustomToast from '@/components/molecules/CustomToast/CustomToast.vue';
import CustomersImportStatus from '@/componentsV2/organisms/CustomerImportStatus/CustomerImportStatus.vue';
import {
  modalComponents,
  modalMapper
} from '@/componentsV2/templates/ModalsDeclaration';
import TopBar from '@/componentsV2/organisms/TopBar/TopBar.vue';
import LeftBar from '@/componentsV2/organisms/LeftBar/LeftBar.vue';
import AdminBar from '@/componentsV2/molecules/AdminBar/AdminBar.vue';
import ImpersonateBar from '@/componentsV2/molecules/ImpersonateBar/ImpersonateBar.vue';
import EducationPlayer from '@/componentsV2/molecules/EducationPlayer/EducationPlayer.vue';
import { IEducationPlayerProps } from '@/componentsV2/molecules/EducationPlayer/EducationPlayer';
import NotificationArrow from '@/componentsV2/molecules/NotificationArrow/NotificationArrow.vue';
import { INotificationArrowProps } from '@/componentsV2/molecules/NotificationArrow/NotificationArrow';
import segmentIo, {
  addSegmentScript,
  shouldShowTrackingDebugger,
  trackingDebuggerIsActive
} from '@/utils/segment.io';
import { OnboardingURL, getSignUpUrlRoutes } from '@/views/Onboarding/helpers';

import BackendAvailabilityService from '@/api/BackendAvailability';
import MaintenanceKeys from '@/constants/maintenance';
import GuidedTours from './componentsV2/templates/GuidedTours/GuidedTours.vue';
import { sleep } from './utils';
import ScheduleOnboardingBar from './componentsV2/molecules/ScheduleOnboardingBar/ScheduleOnboardingBar.vue';
import { getShowOnboardingCallBanner } from './utils/onboardingCall';
import { isRemoteLoading } from '@/utils/remote-loading';

@Component({
  components: {
    ...modalComponents,
    ClipLoader,
    ScreenLocker,
    SideModal,
    ForgotPassword,
    CustomToast,
    ConfirmDialog,
    NotificationArrow,
    TopBar,
    LeftBar,
    AdminBar,
    ImpersonateBar,
    CustomersImportStatus,
    EducationPlayer,
    GuidedTours,
    ScheduleOnboardingBar
  }
})
export default class App extends Vue {
  @Prop() featureFlags!: string[];

  dragTimer: any = null;
  campaignService: CampaignService = new CampaignService();
  adminService: AdminService = new AdminService();
  businessService: BusinessService = new BusinessService();
  backendAvailabilityService = new BackendAvailabilityService();
  key = 0;

  loadingTimeout?: NodeJS.Timeout;

  sideModalComponent: string = '';
  sideModalState: boolean = false;
  sideModalData: any = {};
  subSideModalState: boolean = false;
  subSideModalComponent: string = '';
  sideModalProps: any = {};

  modalProps: any = null;
  modalVisible: boolean = false;
  modalOptions!: ModalOptions;

  submodalOptions!: ModalOptions;
  submodalVisible: boolean = false;
  submodalProps: any = null;

  educationPlayerProps: Partial<IEducationPlayerProps> = {};

  notificationArrowProps: Partial<INotificationArrowProps> = {};

  notificationMenu: String[] = [];
  loadingInstances: Number[] = [];
  lockerInstances: Number[] = [];

  loadingWithoutTimer = false;

  loaderColor: string = '#333333';
  hasMediumBackgroundLocker: boolean = false;
  centerWithoutSideBar: boolean = true;

  noPaddingBottom: boolean = false;

  showSideMenu = false;

  modalMapper: any = modalMapper;

  get isRemoteLoading() {
    return isRemoteLoading();
  }

  handleNotificationClose({ close, item }: Record<string, any>) {
    if (item.data && item.data.onMessageClick) {
      close();
      item.data.onMessageClick();

      return;
    }

    close();
  }

  async listenerZendeskOpen() {
    if ((window as any).zE) return;
    await sleep(500);

    if (window.zE) {
      window.zE('webWidget:on', 'open', function() {
        segmentIo.track('Clicked Support Twism Button');
      });
      window.zE('webWidget:on', 'close', function() {
        segmentIo.track('Closed Support Twism Button');
      });
    }
  }

  removeSensitiveInfoFromURL() {
    const sensitiveParams = ['token'];

    sensitiveParams.forEach(param => {
      const urlParams = new URLSearchParams(location.search);
      if (urlParams.has(param)) {
        urlParams.delete(param);
        window.history.replaceState(
          null,
          null as any,
          `${window.location.pathname}?` + urlParams.toString()
        );
      }
    });
  }

  created() {
    setCSSVariables();

    this.addEventListeners();
    this.registerGlobalMethods();
    closeIframeAfterSigninConnect();
  }

  async mounted() {
    this.removeSensitiveInfoFromURL();
    addHotjarScript({
      isImpersonated: this.isImpersonated,
      isSuperAdmin: this.isSuperAdmin
    });

    addSegmentScript({
      isImpersonated: this.isImpersonated,
      isSuperAdmin: this.isSuperAdmin,
      featureFlags: this.featureFlags
    });

    this.checkBackendStatus();
    this.listenerZendeskOpen();
  }

  async checkBackendStatus() {
    const {
      available: backendIsAvailable
    } = await this.backendAvailabilityService.getStatus(this.featureFlags);

    if (!backendIsAvailable) {
      this.$router.push('/maintenance');

      localStorage.setItem(
        MaintenanceKeys.LAST_ROUTE_BEFORE_MAINTENANCE_STORAGE_KEY,
        location.pathname
      );
    }
  }

  handleShowSideMenu(state: boolean) {
    this.showSideMenu = state;
  }

  updateBusiness() {
    this.businessService.getBusinessInfo().then((res: any) => {
      eventBus.$emit('setBusinessInfo', res.data);
      const data = res.data;
      data.manager = data.loggedInManager;
      this.$store.dispatch('business/SET_BUSINESS_INFO', data);
    });
  }

  registerGlobalMethods() {
    Vue.prototype['$analytics'] = this.analytics;
    Vue['analytics'] = this.analytics;

    Vue.prototype['$mobileCheck'] = mobileCheck;

    Vue.prototype['$notification'] = this.notification;

    Vue.prototype['$cdn'] = this.cdn;

    Vue['notification'] = this.notification;

    Vue.prototype['$showLoader'] = this.showLoader;
    Vue['showLoader'] = this.showLoader;

    Vue.prototype['$showConfirmDialog'] = this.showConfirmDialog;
    Vue['showConfirmDialog'] = this.showConfirmDialog;

    Vue.prototype['$lock'] = this.lock;
    Vue['lock'] = this.lock;

    Vue.prototype['$unlock'] = this.unlock;
    Vue['unlock'] = this.unlock;

    Vue.prototype[
      '$showMediumBackgroundLocker'
    ] = this.showMediumBackgroundLocker;

    Vue.prototype[
      'showMediumBackgroundLocker'
    ] = this.showMediumBackgroundLocker;

    Vue.prototype[
      '$hideMediumBackgroundLocker'
    ] = this.hideMediumBackgroundLocker;
    Vue.prototype[
      'hideMediumBackgroundLocker'
    ] = this.hideMediumBackgroundLocker;

    Vue.prototype['$showLoaderWithLocker'] = this.showLoaderWithLocker;
    Vue['showLoaderWithLocker'] = this.showLoaderWithLocker;

    Vue.prototype['$hideLoader'] = this.hideLoader;
    Vue['hideLoader'] = this.hideLoader;
  }

  @Watch('$route')
  onRouteChange() {
    this.educationPlayerProps = {};
  }

  addEventListeners() {
    eventBus.$on('setBusinessInfo', async (businessData?: any) => {
      const { data } = businessData
        ? { data: businessData }
        : await this.businessService.getBusinessInfo();

      if (!data.pendingActions) return;

      if (data.pendingActions.businessClaimCode && !this.isImpersonated) {
        this.$router.push(
          `/invite-merchant/${data.pendingActions.businessClaimCode}`
        );
      }
    });

    eventBus.$on('setSideModalVisible', (state: any) => {
      const { isOpen, component, data, subModal, ...props } = state;

      this.sideModalProps = props;
      this.sideModalState = isOpen;
      this.sideModalComponent = component;
      this.sideModalData = data;
      this.subSideModalState = subModal && subModal.isOpen;
      this.subSideModalComponent = subModal && subModal.component;

      if (component === 'newCampaingnModal') {
        this.noPaddingBottom = true;
      } else {
        this.noPaddingBottom = false;
      }
    });

    eventBus.$on('hideSubModal', () => {
      this.subSideModalState = false;
      this.subSideModalComponent = '';
    });

    eventBus.$on('reloadPage', (confirm: boolean) => {
      if (confirm) {
        window.location.reload();
      }
    });

    eventBus.$on('showNotification', (labelKey: string) => {
      this.$notification(`${this.$t(labelKey)}`);
    });

    eventBus.$on('openModal', (value: ModalOptions, modalProps: any) => {
      this.modalProps = modalProps;
      this.modalOptions = value;
      this.modalVisible = true;
    });

    eventBus.$on(
      'openEducationPlayer',
      (educationPlayerProps: IEducationPlayerProps) => {
        this.educationPlayerProps = educationPlayerProps;
      }
    );

    eventBus.$on('closeEducationPlayer', () => {
      this.educationPlayerProps = {};
    });

    eventBus.$on('setNotificationMenu', (notificationMenu: String[]) => {
      this.notificationMenu = notificationMenu;
    });

    eventBus.$on('clearNotificationMenu', () => {
      this.notificationMenu = [];
    });

    eventBus.$on(
      'openNotificationArrow',
      (notificationArrowProps: INotificationArrowProps) => {
        this.notificationArrowProps = notificationArrowProps;
      }
    );

    eventBus.$on('closeNotificationArrow', () => {
      this.notificationArrowProps = {};
    });

    eventBus.$on('openSubModal', (value: ModalOptions, modalProps: any) => {
      setTimeout(() => {
        this.submodalProps = modalProps;
        this.submodalOptions = value;
        this.submodalVisible = true;
        this.disableScroll();
        this.key++;
      }, 0);
      Vue.prototype['$modal'] = this.modal;
    });

    eventBus.$on('disableScroll', () => {
      this.disableScroll();
    });
    eventBus.$on('enableScroll', () => {
      this.enableScroll();
    });

    eventBus.$on('closeModal', (payload?: Record<string, any>) => {
      const onClose = () => {
        if (this.submodalVisible) {
          this.submodalVisible = false;
        } else {
          this.modalVisible = false;
        }

        if (this.submodalOptions) this.submodalOptions = undefined as any;
        this.enableScroll();
        Vue.prototype['$modal'] = this.modal;
      };
      if (payload && payload.continueModal) {
        onClose();
      } else {
        setTimeout(() => onClose(), 0);
      }
    });

    eventBus.$on('sideModalChanged', this.sideModalChanged);
    eventBus.$on('showLoaderWithLocker', this.showLoaderWithLocker);
    eventBus.$on('hideLoader', this.hideLoader);
    eventBus.$on('showMediumBackgroundLocker', this.showMediumBackgroundLocker);
    eventBus.$on('hideMediumBackgroundLocker', this.hideMediumBackgroundLocker);
    eventBus.$on('updateBusiness', this.updateBusiness);
  }

  disableScroll() {
    const scrollY = window.scrollY;
    const { body } = document;
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.right = '0px';
    body.style.left = '0px';
    body.style.overflow = 'hidden';
    if (this.submodalOptions && this.submodalOptions.mobileFullScreen) {
      body.classList.add('hidden');
    }
  }

  enableScroll() {
    const { body } = document;
    const { top } = body.style;
    const yValue = -parseInt(top || '0', 10);
    body.style.position = '';
    body.style.top = '';
    body.style.overflow = '';
    body.classList.remove('hidden');
    window.scrollTo(0, yValue);
  }

  sideModalChanged(state: boolean) {
    this.centerWithoutSideBar = state;
  }

  lock() {
    this.lockerInstances.push(this.lockerInstances.length + 1);
  }

  unlock() {
    this.lockerInstances.pop();
  }

  showMediumBackgroundLocker() {
    this.hasMediumBackgroundLocker = true;
  }

  hideMediumBackgroundLocker() {
    this.hasMediumBackgroundLocker = false;
  }

  analytics(
    data: AnalyticsOptions,
    sendTo: Array<AnalyticsSendTo> = ['ga', 'gtag']
  ) {
    const analitycsMapper: Record<AnalyticsSendTo, any> = {
      ga: () => {
        this.$ga.event({
          eventCategory: data.eventCategory,
          eventLabel: data.eventLabel,
          eventAction: data.eventAction
        });
      },
      gtag: () => {
        this.$gtag.event(`${data.eventCategory}-${data.eventLabel}`, {
          event_category: data.eventCategory,
          event_label: data.eventLabel
        });
      }
    };

    for (const name of sendTo) {
      if (!analitycsMapper[name]) continue;

      analitycsMapper[name]();
    }
  }

  showLoader(withoutTimer = false) {
    this.loadingWithoutTimer = withoutTimer;
    this.loadingInstances.push(this.loadingInstances.length + 1);
  }

  async showConfirmDialog(options = {}) {
    const confirmDialog = this.$refs.confirmDialog as any;

    if (!confirmDialog) {
      return Promise.reject(new Error('Confirm dialog not found'));
    }

    window.parent.postMessage(
      { type: 'eventbus:emit', data: { event: 'openSubModal' } },
      '*'
    );

    const response: ConfirmDialogCallbacks = await confirmDialog.show(options);

    return response;
  }

  @Watch('loaderIsVisible')
  changedLoading() {
    if (this.loaderIsVisible && !this.loadingWithoutTimer) {
      this.loadingTimeout = setTimeout(() => {
        this.loadingInstances = [];
        this.lockerInstances = [];
      }, 5000);
    } else if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }
  }

  hideLoader() {
    this.loadingWithoutTimer = false;
    this.loadingInstances.pop();
    this.lockerInstances.pop();
  }

  showLoaderWithLocker(withoutTimer = false) {
    this.loadingWithoutTimer = withoutTimer;
    this.loadingInstances.push(this.loadingInstances.length + 1);
    this.lockerInstances.push(this.lockerInstances.length + 1);
  }

  getNotificationIconByType(type: string) {
    const iconsLabels: { [i: string]: string } = {
      success: 'option-selected',
      error: 'option-deselected',
      warn: 'warning-solid',
      info: 'attention'
    };

    return iconsLabels[type] || 'option-selected';
  }

  notification(
    text: string,
    type = 'success',
    duration = 6000,
    options?: INotificationData
  ) {
    window.parent.postMessage(
      {
        type: 'notification',
        data: {
          message: text,
          type
        }
      },
      '*'
    );
    if (!isRemoteLoading()) {
      this.$notify({
        group: 'message',
        type,
        text: text,
        duration: duration,
        ...(options && {
          data: options
        })
      });
    }

    if (type === 'error') {
      sendEventHotjarByTypeAndDescription({
        typeEvent: IHotjarEventType.ERROR,
        description: IHotjarEventDescritpion.TOAST
      });
    }
  }

  cdn(relativeAssetPath: string) {
    return cdnBaseURL(relativeAssetPath);
  }

  customDrag(status: boolean, event: any) {
    eventBus.$emit('custom.drag', status, event);
  }

  drop(event: any) {
    this.customDrag(false, event);
    eventBus.$emit('drop', event);
  }

  dragover(event: any) {
    eventBus.$emit('dragover', event);
    this.customDrag(true, event);
    clearTimeout(this.dragTimer);
  }

  dragleave(event: any) {
    eventBus.$emit('dragleave', event);
    this.dragTimer = setTimeout(() => {
      this.customDrag(false, event);
    }, 10);
  }

  dragenter(event: any) {
    // For Firefox / IE
    if (event.originalEvent) {
      event.originalEvent.dataTransfer.setData('text', 'anything');
    }

    eventBus.$emit('dragenter', event);
    this.customDrag(true, event);
  }

  get modal() {
    return {
      visible: this.submodalVisible,
      props: this.submodalProps,
      options: this.submodalOptions
    };
  }

  get lockerIsActive() {
    return !!this.lockerInstances.length;
  }

  get loaderIsVisible() {
    return !!this.loadingInstances.length;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get showEducationPlayer() {
    return (
      Object.keys(this.educationPlayerProps).length > 0 &&
      this.flags.includes(flagKeys.videoEducation)
    );
  }

  get showNotificationArrow() {
    return Object.keys(this.notificationArrowProps).length > 0;
  }

  get shouldShowZendeskWidget() {
    if (
      this.$store.getters['flags/getFlags'].includes('zendesk-business-support')
    ) {
      return !this.$route.meta.superRoot;
    }
    return false;
  }

  get hasAdminBar() {
    return this.$route.meta.superRoot;
  }

  get showTopBar() {
    return this.$route.meta.requiresAuth && this.$route.meta.navbar;
  }

  get showScheduleOnboardingBar() {
    return (
      this.$route.meta.requiresAuth &&
      this.$route.meta.navbar &&
      !this.hasAdminBar &&
      getShowOnboardingCallBanner()
    );
  }

  get showLeftBar() {
    return this.$route.meta.requiresAuth && this.$route.meta.navbar;
  }

  get isImpersonated() {
    return this.$store.getters['manager/isImpersonated'];
  }

  get isSuperAdmin() {
    return APIService.isSuperAdmin();
  }

  get trackingDebuggerIsActive() {
    return shouldShowTrackingDebugger() && trackingDebuggerIsActive();
  }
}
